import type { ChatSessionSummary } from "@/features/chat/model/chatHistoryTypes";

export function getChatSessionDisplayTitle(
  session: ChatSessionSummary,
  untitledLabel: string,
): string {
  const trimmedTitle = session.title?.trim();
  return trimmedTitle ? trimmedTitle : untitledLabel;
}

export function filterChatSessionsByTitle(
  sessions: ChatSessionSummary[],
  searchQuery: string,
  untitledLabel: string,
): ChatSessionSummary[] {
  const normalizedQuery = searchQuery.trim().toLowerCase();
  if (!normalizedQuery) {
    return sessions;
  }

  return sessions.filter((session) => {
    const displayTitle = getChatSessionDisplayTitle(session, untitledLabel).toLowerCase();
    return displayTitle.includes(normalizedQuery);
  });
}
